import { ErrorBoundary } from '@sentry/react';
import { SideNav } from '../common/SideNav';
import { FallbackSideNav } from '../fallback/FallbackSideNav';
import { CrossPlatformSideNavFooterLinks } from './CrossPlatformSideNavFooterLinks';
import { CrossPlatformSideNavLinks } from './CrossPlatformSideNavLinks';

export const CrossPlatformSideNav = () => (
  <ErrorBoundary fallback={<FallbackSideNav />}>
    <span data-testid="cross-platform-side-nav" />
    <SideNav
      SideNavMainComponent={CrossPlatformSideNavLinks}
      SideNavFooterComponent={CrossPlatformSideNavFooterLinks}
    />
  </ErrorBoundary>
);
